import { useEffect, useState } from "react";
import { adminApi } from "@/admin/AdminAuthContext";
import AdminPageShell from "@/admin/AdminPageShell";

const MODULES = ["dashboard", "brands", "pages", "blog", "gallery", "media", "testimonials", "appointments", "newsletter", "seo", "analytics", "users", "roles", "approvals", "audit_log", "settings"];

const AdminRoles = () => {
  const [roles, setRoles] = useState([]);
  useEffect(() => { adminApi.get("/roles").then((res) => setRoles(res.data)); }, []);

  return (
    <AdminPageShell title="Roles" description="Predefined roles and their permission summaries. The Owner role is permanent and cannot be edited or removed." testId="admin-roles-page">
      <div className="space-y-6">
        {roles.map((r) => (
          <div key={r.key} className="neu-panel p-6" data-testid={`admin-role-${r.key}`}>
            <div className="flex items-center gap-3 mb-2">
              <h3 className="text-h4">{r.name}</h3>
              {r.is_permanent && <span className="eyebrow" style={{ color: "var(--gg-logo-gold)" }}>Permanent</span>}
            </div>
            <p className="text-small mb-4">{r.description}</p>
            <div className="flex flex-wrap gap-2">
              {MODULES.map((m) => {
                const level = r.permissions?.[m] || "none";
                if (level === "none") return null;
                return (
                  <span key={m} className="text-small border rounded-full px-3 py-1" style={{ borderColor: "var(--gg-fine-border)", color: level === "write" ? "var(--gg-logo-gold)" : "var(--gg-secondary-text)" }}>
                    {m} &middot; {level}
                  </span>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </AdminPageShell>
  );
};

export default AdminRoles;
